import { render } from "./CoursesList.vue?vue&type=template&id=36e3e80f"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__